import type { SubtitleStore, SubtitleSlot } from '../../state/subtitleStore.ts';

/** Resolve BCP-47-ish language code for a subtitle slot (learning popup / TTS). */
export function resolveSlotLanguage(
  store: SubtitleStore,
  slot: SubtitleSlot,
): string | undefined {
  const state = store.getSlot(slot);
  const list = state.trackList;
  if (!list) return undefined;

  const selectedId = state.selectedId;
  const track = list.subtitles.find((t) => String(t.value) === selectedId);
  if (track?.code) return track.code;

  const cues = state.cues;
  const lang = cues?.[0]?.lang;
  if (lang) return String(lang);

  return undefined;
}
